module.exports = __webpack_public_path__ + "media/bootstrap-icons/badge-ad-521a8750.svg";